import { reactQueryPost } from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

const validateEmail = (email: string) =>
  reactQueryPost(internalApi.emailValidations.create(), { email });

export const emailValidationsApi = {
  validateEmail,
};
